import React, { useState } from 'react';
import AudioToTextInput from '../../BaseModule/Components/Inputs/AudioToTextInput/AudioToTextInput';
import Video from '../../Base/Components/Video/Video';

interface Props {
	video: string;
	name: string;
	netteRules?: any;
	isRequired?: boolean;
	timeLimitInSeconds?: number;
}

const VideoWithAudioInput: React.FC<Props> = ({
	video,
	name,
	isRequired,
	timeLimitInSeconds,
	netteRules,
}) => {
	const [recording, setRecording] = useState(false);

	const handleRecordingEnd = () => {
		setTimeout(() => {
			const btn = document.getElementById(
				'audioAnswerSubmit',
			) as HTMLButtonElement | null;
			btn?.click();
		}, 1000);
	};

	const handleVideoEnd = () => {
		setRecording(true);
	};

	return (
		<div>
			<Video
				videoSrc={video}
				className='videoWrapper__video'
				autoPlay
				controls
				onEnded={handleVideoEnd}
			/>
			<AudioToTextInput
				name={name}
				netteRules={netteRules}
				timeLimitInSeconds={timeLimitInSeconds}
				isRequired={isRequired}
				autoStartRecording={recording}
				onRecordingEnded={handleRecordingEnd}
			/>
		</div>
	);
};

export default VideoWithAudioInput;
